import { Button, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../../AxiosInstance";
import { useNavigate } from "react-router-dom";
import { amountFormat } from "../../../../utils";

export default function TrackAssignmentPhView() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [status, setStatus] = useState("ACTIVE");
  const navigate = useNavigate();
  var [dataSource, setDataSource] = useState([]);
  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    getTableData(0);
  }, []);
  const getTableData = async (skip) => {
    const url = `partner/referral/policies?take=10&skip=${skip}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;

        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const columns = [
    {
      title: "Policy Number",
      dataIndex: "policy.policyNumber",
      align: "center",
      key: "policy.policyNumber",
      render: (text, policy) => <>{policy.policy.policyNumber}</>,
    },

    {
      title: "Name of PH",
      dataIndex: "name",
      key: "name",
      render: (text, policy) =>
        policy?.policy?.user["firstName"] +
        " " +
        policy?.policy?.user["lastName"],
    },
    {
      title: "Insurer",
      dataIndex: "insurer",
      key: "insurer",
      align: "center",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy.policy?.insurer?.logo}
          />
        </>
      ),
    },

    {
      title: "Assignment Offer Amount",
      dataIndex: "policy",
      align: "right",
      key: "policy",
      render: (text, policy) => amountFormat(text.assignmentOfferAmount),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
    },
    {
      title: "Refer Date",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    },
  ];
  const change = (data) => {
    getTableData((data - 1) * 10);
  };

  return (
    <div>
      <Button
        onClick={() => {
          navigate("/referpage");
        }}
      >
        Refer User
      </Button>
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />
    </div>
  );
}
